// Satuan jual: satuan dasar produk (harga `price`) atau satuan kedua (mis. Krt, harga `price2`).
// factor = isi satu satuan jual dalam satuan dasar → dipakai untuk stok & HPP.

export interface ProductUnits {
  unit: string;
  price: number;
  unit2?: string | null;
  price2?: number | null;
  unit2_factor?: number | null;
}

export interface SaleUnit {
  unit: string;
  price: number;
  factor: number;
}

/** Daftar satuan yang bisa dipilih untuk produk (dasar dulu, lalu satuan kedua bila berharga). */
export const unitsOf = (p: ProductUnits): SaleUnit[] => [
  { unit: p.unit, price: p.price, factor: 1 },
  ...(p.unit2 && (p.price2 ?? 0) > 0
    ? [{ unit: p.unit2, price: p.price2 as number, factor: (p.unit2_factor ?? 0) > 0 ? (p.unit2_factor as number) : 1 }]
    : []),
];

/** Cari satuan jual dari nama satuan (tanpa beda huruf besar/kecil; kosong = satuan dasar). null bila tidak tersedia. */
export const findUnit = (p: ProductUnits, u: string | null | undefined): SaleUnit | null => {
  const want = String(u || '')
    .trim()
    .toLowerCase();
  if (!want) return unitsOf(p)[0] ?? null;
  return unitsOf(p).find((x) => x.unit.toLowerCase() === want) ?? null;
};
